import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Options } from '@popperjs/core';
import { Subscription } from 'rxjs';
import { OrderListsViewTypeService } from '../../../orders/services/order-lists-view-type.service';
import { SharedModule } from '../../../shared/shared.module';
import { LocalStorageKeys } from '../../constants/local-storage.constants';
import { OrderListsViewTypeEnum } from '../../enums/order-lists-view.enum';

@Component({
  selector: 'app-order-lists-view-type-switch',
  templateUrl: './order-lists-view-type-switch.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule],
})
export class OrderListsViewTypeSwitchComponent implements OnInit, AfterViewInit, OnDestroy {
  orderListsViewService = inject(OrderListsViewTypeService);
  private cdr = inject(ChangeDetectorRef);

  @ViewChild('popover') popover: NgbPopover;

  activeOrderListsViewType: OrderListsViewTypeEnum = OrderListsViewTypeEnum.ORDERS_MANAGEMENT;
  orderListsViewTypeEnum = OrderListsViewTypeEnum;

  private subscriptions: Subscription = new Subscription();

  ngOnInit() {
    this.subscriptions.add(
      this.orderListsViewService.getOrderListsViewTypeAsObservable().subscribe((view) => {
        this.activeOrderListsViewType = view;
      }),
    );
  }

  ngAfterViewInit() {
    const showInstructions = localStorage.getItem(LocalStorageKeys.ORDERS_VIEW_SWITCH_INTRO_DISMISSED);
    if (showInstructions === null) {
      this.popover?.open();
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  switchOrdersView(view: OrderListsViewTypeEnum) {
    if (this.activeOrderListsViewType === view) {
      return;
    }
    this.orderListsViewService.setOrderListsViewType(view);
  }

  onDontShowAgain() {
    localStorage.setItem(LocalStorageKeys.ORDERS_VIEW_SWITCH_INTRO_DISMISSED, 'false');
    this.popover?.close();
  }

  introPopperOptions = (options: Partial<Options>) => {
    for (const modifier of options.modifiers || []) {
      if (modifier.name === 'offset' && modifier.options) {
        modifier.options.offset = () => [124, 20];
      }
    }
    return options;
  };
}
